export default __webpack_public_path__ + "static/media/jaguar.404ff489.svg";